import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { localStorageService } from 'src/app/components/shared/localstorage.service';

// Dedicated landing page for the Google OAuth popup opened by
// MainLayoutComponent#connectGmail(). The backend's /auth/google/callback
// redirects the POPUP window here (not the main tab) with
// ?gmail=connected|error&... in the query string.
//
// This page's only job: read that result, hand it to the main tab via a
// storage event (the only same-origin, cross-window channel available
// without a server round-trip of its own), and close itself. It is NOT
// behind authGuard -- a popup freshly returned from Google has no
// Authorization header to present, same reason the backend callback route
// sits in front of its own auth middleware.
const RESULT_STORAGE_KEY = 'gmail_auth_popup_result';

@Component({
  selector: 'app-gmail-auth-result',
  template: `<p class="p-4">Finishing Gmail connection&hellip;</p>`,
})
export class GmailAuthResultComponent implements OnInit {
  constructor(private route: ActivatedRoute, private _local: localStorageService) {}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const status = params.get('gmail');
    if (!status) {
      window.close();
      return;
    }

    const result: any = { status, ts: Date.now() };
    if (status === 'connected') {
      result.email = params.get('email') || '';
    } else {
      result.reason = params.get('reason') || 'unknown';
      const expected = params.get('expected');
      if (expected) result.expected = expected;
    }

    // customSetItem (not plain localStorage.setItem) so this writes to the
    // SAME blob key the rest of the app reads/writes through
    // localStorageService -- a storage event only fires on the key that
    // actually changed, and the opener listens for that one key.
    this._local.customSetItem(RESULT_STORAGE_KEY, result);

    // A same-window write doesn't fire a storage event in THIS window
    // (only other windows/tabs on the same origin get notified), so the
    // opener's listener in main-layout.component.ts picks this up
    // naturally. Give the write a moment to flush before closing.
    setTimeout(() => window.close(), 50);
  }
}
